module.exports = __webpack_public_path__ + "img/avenir_health.a6b23ff2.png";